export type BreakpointValues = {
  mobile?: string;
  tablet?: string;
  desktop?: string;
  widescreen?: string;
  fullhd?: string;
  ultrahd?: string;
};

export const breakpointValuesToClassNames = (
  breakpointValues: BreakpointValues,
  suffix: string,
  styles: {
    readonly [key: string]: string;
  },
) => {
  let classNames = "";
  if (breakpointValues.mobile) {
    classNames += ` ${styles[`mobile-${suffix}`]}`;
  }
  if (breakpointValues.tablet) {
    classNames += ` ${styles[`tablet-${suffix}`]}`;
  }
  if (breakpointValues.desktop) {
    classNames += ` ${styles[`desktop-${suffix}`]}`;
  }
  if (breakpointValues.widescreen) {
    classNames += ` ${styles[`widescreen-${suffix}`]}`;
  }
  if (breakpointValues.fullhd) {
    classNames += ` ${styles[`fullhd-${suffix}`]}`;
  }
  if (breakpointValues.ultrahd) {
    classNames += ` ${styles[`ultrahd-${suffix}`]}`;
  }
  return classNames;
};
